
import { defineComponent, ref } from "vue";
import Permission from "@/core/config/Permission";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import axios from "@/axios-instance"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { hideModal } from "@/core/helpers/dom";
import Dropzone from "dropzone";


interface ICustomer {
    id: string;
    name: string;
    type: string;
    code?: string;
}
interface IPagination {
    currentPage: number;
    total: number;
    limit: number;
}
interface IData {
    name: string;
    type: string;
    code: string;
    level: string;
    productid: string;
    tuitionFee: string;
    uomid: string;

}
export default defineComponent({
    name: "Combination-code",
    components: {
        Datatable,
    },
    data() {
        return {
        }
    },
    methods: {
        importFile() {
            setTimeout(()=>{
                this.initDropzone()
            },100)
        },
        getCookie(name: string): string|null {
            const nameLenPlus = (name.length + 1);
            return document.cookie
                .split(';')
                .map(c => c.trim())
                .filter(cookie => {
                return cookie.substring(0, nameLenPlus) === `${name}=`;
                })
                .map(cookie => {
                return decodeURIComponent(cookie.substring(nameLenPlus));
                })[0] || null;
        },
        initDropzone() {
            let this_ = this
            if (Dropzone.instances.length > 0) {
                Dropzone.instances.forEach((e: any) => {
                    e.off();
                    e.destroy();
                });
            }
            let myDropzone = new Dropzone("#id_dropzone", { 
                url:`${process.env.VUE_APP_API_URL}/admission/passed/synchronize`,
                headers:{"Authorization":'Bearer ' + this.getCookie("accessToken")}, 
                dictDefaultMessage: "Nhấn vào đây để import file excel",
                dictInvalidFileType: "Bạn không thể tải tệp không đúng định dạng",
                dictFileTooBig: "Kích thước tệp quá lớn. Tối đa 25MB",
                dictMaxFilesExceeded: "Bạn chỉ được upload tối đa 1 files",
                maxFilesize: 25,
                maxFiles: 1,
                addRemoveLinks: true,
                acceptedFiles: `text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
                init: function () {
                    var startUpload = document.getElementById("uploadFiles");
                    myDropzone = this;
                    myDropzone.removeAllFiles()
                    document.querySelectorAll(".dz-preview").forEach(e => e.remove());
                    startUpload?.addEventListener("click", function (file) {
                        // console.log('file',file)
                        myDropzone.processQueue();
                        
                    });
                    this.on("removedfile",async function (file) {
                        // if(file && file.fileName) {
                        //     await axios.delete(`/admission/file/${file.fileName}`)
                        // }
                    });
                    this.on("success",async function (file, response) {
                        console.log('response',response)
                    });
                    this.on("error",function (file, response) {
                        console.log('response',response)
                        Swal.fire({
                            text: response.message,
                            icon: "error",
                            buttonsStyling: false,
                            confirmButtonText: "Trở lại",
                            customClass: {
                                confirmButton: "btn btn-primary",
                            },
                        }).then(() => {
                            Swal.close()
                        });  

                    })
                }
            });
        },
        callModalAddApp(e) {
            e.preventDefault()
            this.isEdit = false
            this.kt_modal_add_combination?.click()
            this.resetDataForm()
        },
        resetDataForm() {
            if (!this.formRef) return
            this.formRef.resetFields()
            let temp = {
                "type": '',
                "name": "",
                "code": "",
                "level": "",
                "productid": "",
                "uomid": "",
                "tuitionFee": "",
            }
            this.formData = temp
        },
        deleteRow(record) {
            Swal.fire({
                text: `Bạn có muốn xóa môn học này không?`,
                icon: "question",
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Đồng ý",
                cancelButtonText: "Trở lại",
                customClass: {
                    confirmButton: "btn btn-primary order-2",
                    cancelButton: "btn btn-light order-1",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    let index = this.tableData.findIndex(item => item.id == record.id)
                    this.tableData.splice(index, 1);
                    axios.delete(`/setting/subject/${record.id}`)
                }
                Swal.close()
            });
        },
        async setDataForm(record) {
            // console.log('setDataForm',record)
            // this.resetDataForm()
            this.formRef?.resetFields()
            this.idFormEdit = record.id
            await axios.get(`/setting/subject/${record.id}`)
            .then(({ data }) => {
                this.formData = data
                this.isEdit = true
                this.kt_modal_add_combination?.click()
            })
            .catch(({ response }) => {
                console.log('err', response)
            });
            

        }
    },

    async mounted() {
        await axios.get(`/setting/subject`)
            .then(({ data }) => {
                data = data.sort(function(a, b){
                    if(a.name < b.name) { return -1; }
                    if(a.name > b.name) { return 1; }
                    return 0;
                })
                data.forEach(item => {
                    let temp = {
                        id: item.id,
                        name: item.name,
                        code: item.code,
                        type: item.type,
                        level: item.level,
                        productid: item.productid,
                        uomid: item.uomid,
                        tuitionFee: item.tuitionFee,
                    }
                    this.tableData.push(temp)
                })
            })
            .catch(({ response }) => {
                console.log('err', response)
            });
    },
    setup() {
        Dropzone.autoDiscover = false;
        const kt_modal_add_combination = ref<null | HTMLElement>(null);
        const addCombinationModalRef = ref<null | HTMLElement>(null);
        const isEdit = ref(false);
        const idFormEdit = ref('');

        const pagination = ref<IPagination>({
            currentPage: 1,
            total: 0,
            limit: 1000,
        });
        const tableHeader = ref([
            {
                name: "Mã môn học",
                key: "code",
                sortable: true,
                class: "w-150px",
            },
            {
                name: "Tên môn học",
                key: "name",
                sortable: true,
            },
            {
                name: "Loại môn học",
                key: "type",
                sortable: true,
            },
            {
                name: "Giá",
                key: "tuitionFee",
                sortable: true,
            },
            {
                name: "HÀNH ĐỘNG",
                key: "actions",
                sortable: false,
                class: "text-center"
            },
        ]);
        const optionType = [{ label: 'Ngoại ngữ', value: 'foreign_lang' }, { label: 'Giáo dục thể chất', value: 'physical_edu' }]
        const formData = ref<IData>(
            { 
                "name": "",
                "code": "",
                "type": "",
                "level": "",
                "productid": "",
                "uomid": "",
                "tuitionFee": "",
            })
        const tableData = ref<Array<ICustomer>>([]);
        const arrMajors = ref([]) as any;
        const formRef = ref<HTMLFormElement | null>(null);
        const rules = ref({
            name: {
                required: true,
                message: "Vui lòng điền trường này",
                trigger: "change",
            },
            type: {
                required: true,
                message: "Vui lòng điền trường này",
                tringger: "change"
            },
            code: {
                required: true,
                message: "Vui lòng điền trường này",
                tringger: "change"
            }
        })
        const submit = () => {
            if (!formRef.value) {
                return;
            }
            formRef.value.validate(async (valid) => {
                if (valid) {
                    let method = isEdit.value ? 'put' : 'post'
                    let id = isEdit.value ? `/${idFormEdit.value}` : ''
                    let data = {
                        "name": formData.value.name != "" ? formData.value.name : undefined,
                        "code": formData.value.code != "" ? formData.value.code : undefined,
                        "type": formData.value.type != "" ? formData.value.type : undefined,
                        "level": formData.value.level != "" ? +formData.value.level : undefined,
                        "productid": formData.value.productid != "" ? formData.value.productid : undefined,
                        "uomid": formData.value.uomid != "" ? formData.value.uomid : undefined,
                        "tuitionFee": formData.value.tuitionFee != "" ? formData.value.tuitionFee : undefined,
                    }
                    await axios[method](`/setting/subject${id}`, data)
                        .then(({ data }) => {
                            let temp = {
                                id: data.id,
                                name: data.name,
                                code: data.code,
                                type: data.type,
                                level: data.level,
                                productid: data.productid,
                                uomid: data.uomid,
                                tuitionFee: data.tuitionFee,
                            }
                            if (!isEdit.value) {
                                tableData.value.push(temp)
                            }
                            else {
                                let index = tableData.value.findIndex(item => item.id == data.id)
                                if (index >= 0) {
                                    tableData.value[index] = temp
                                }
                            }
                            hideModal(addCombinationModalRef.value);
                        })
                        .catch(({ response }) => {
                            console.log('err', response)
                        });

                } else {
                    return false;
                }
            });
        };
        return {
            optionType,
            kt_modal_add_combination,
            formRef,
            rules,
            addCombinationModalRef,
            pagination,
            tableHeader,
            tableData,
            Permission,
            arrMajors,
            submit,
            formData,
            isEdit,
            idFormEdit,
        };
    },
});
